export default "__VITE_ASSET__eb27e12c__"